import { render, staticRenderFns } from "./ViewAssets.vue?vue&type=template&id=ba781060"
import script from "./ViewAssets.vue?vue&type=script&lang=js"
export * from "./ViewAssets.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ViewAssets.vue?vue&type=style&index=1&id=ba781060&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports